import {
  GET_REQUESTS,
  SET_REQUESTS,
  SET_UNREAD_REQUESTS,
  GET_REQUESTS_ERROR,
  GET_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  SET_UNREAD_NOTIFICATIONS,
  GET_NOTIFICATIONS_ERROR,
  GET_COMMON_NOTIFICATIONS,
  SET_COMMON_NOTIFICATIONS,
  SET_UNREAD_COMMON_NOTIFICATIONS,
  GET_COMMON_NOTIFICATIONS_ERROR,
  SET_REQUEST_FILTERS,
  RESET_REQUEST_FILTERS
} from './types'
import axios from 'axios'
import Config from 'config'
import store from 'store'
import {
  replaceByTargetFromArray,
  findIndexById,
  moveToFirstById,
  handleTZOffset,
  updateAttrByIdArray,
  getIdArray
} from 'helpers/dataHelpers'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { setNotificationsNumber } from 'utils/auth/actions'


const { apiUrl } = Config.network


export function getRequests(next, sorting, dateRange, search, status, assignee) {
  return function action(dispatch) {
    dispatch({
      type: GET_REQUESTS
    })
    const url = next || `${apiUrl}requests/`
    const params = {}
    if (sorting) {
      params['sorting'] = sorting
    }
    if (dateRange && dateRange['startDate']) {
      params['startDate'] = handleTZOffset(dateRange['startDate'])
    }
    if (dateRange && dateRange['endDate']) {
      params['endDate'] = handleTZOffset(dateRange['endDate'])
    }
    if (search) {
      params['search'] = search
    }
    if (status) {
      params['status'] = status
    }
    if (assignee) {
      params['assignee'] = assignee
    }
    axios.get(url, { params }).then((body) => {
      const { data } = body
      if (next) {
        const { requests } = store.getState().notifications
        dispatch({
          type: SET_REQUESTS,
          payload: {
            requests: [...requests, ...data.results],
            requestsNext: data.next,
            requestsUnreadCount: data.unread_count
          }
        })
      } else {
        dispatch({
          type: SET_REQUESTS,
          payload: {
            requests: data.results,
            requestsNext: data.next,
            requestsUnreadCount: data.unread_count
          }
        })
      }
    }).catch(error => {
      dispatch({
        type: GET_REQUESTS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}


export function getNotifications(next, sorting, dateRange, group, search) {
  return function action(dispatch) {
    dispatch({
      type: GET_NOTIFICATIONS
    })
    const url = next || `${apiUrl}notifications/`
    const params = {}
    if (sorting) {
      params['sorting'] = sorting
    }
    if (dateRange && dateRange['startDate']) {
      params['startDate'] = handleTZOffset(dateRange['startDate'])
    }
    if (dateRange && dateRange['endDate']) {
      params['endDate'] = handleTZOffset(dateRange['endDate'])
    }
    if (group) {
      params['group'] = group
    }
    if (search) {
      params['search'] = search
    }
    axios.get(url, { params }).then((body) => {
      const { data } = body
      if (next) {
        const { notifications } = store.getState().notifications
        dispatch({
          type: SET_NOTIFICATIONS,
          payload: {
            notifications: [...notifications, ...data.results],
            notificationsNext: data.next,
            notificationsUnreadCount: data.unread_count
          }
        })
        dispatch(setNotificationsNumber(data.unread_count))
      } else {
        dispatch({
          type: SET_NOTIFICATIONS,
          payload: {
            notifications: data.results,
            notificationsNext: data.next,
            notificationsUnreadCount: data.unread_count
          }
        })
        dispatch(setNotificationsNumber(data.unread_count))
      }
    }).catch(error => {
      dispatch({
        type: GET_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function getUnreadNotifications() {
  return function action(dispatch) {
    const url = `${apiUrl}notifications/get_unread/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
        dispatch({
          type: SET_UNREAD_NOTIFICATIONS,
          payload: {
            notificationsUnreadCount: data.unread_count
          }
        })
        dispatch(setNotificationsNumber(data.unread_count))
    }).catch(error => {
      dispatch({
        type: GET_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function getUnreadRequests() {
  return function action(dispatch) {
    const url = `${apiUrl}requests/get_unread/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
        dispatch({
          type: SET_UNREAD_REQUESTS,
          payload: {
            requestsUnreadCount: data.unread_count
          }
        })
    }).catch(error => {
      dispatch({
        type: GET_REQUESTS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function setReadNotification(id) {
  return function action(dispatch) {
    const url = `${apiUrl}notifications/${id}/set_read/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
        const { notifications, notificationsNext, notificationsUnreadCount } = store.getState().notifications
        dispatch({
          type: SET_NOTIFICATIONS,
          payload: {
            notifications: replaceByTargetFromArray(notifications, data),
            notificationsNext: notificationsNext,
            notificationsUnreadCount: notificationsUnreadCount - 1
          }
        })
        dispatch(setNotificationsNumber(notificationsUnreadCount - 1))
    }).catch(error => {
      dispatch({
        type: GET_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function setReadNotifications(ids) {
  return function action(dispatch) {
    const { notifications, notificationsNext, notificationsUnreadCount } = store.getState().notifications
    dispatch({
      type: SET_NOTIFICATIONS,
      payload: {
        notifications: updateAttrByIdArray(notifications, ids, 'read', true),
        notificationsNext: notificationsNext,
        notificationsUnreadCount: notificationsUnreadCount - ids.length
      }
    })
    dispatch(setNotificationsNumber(notificationsUnreadCount - ids.length))
  }
}

export function setReadRequest(id) {
  return function action(dispatch) {
    const url = `${apiUrl}requests/${id}/set_read/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
        const { requests, requestsNext, requestsUnreadCount } = store.getState().notifications
        dispatch({
          type: SET_REQUESTS,
          payload: {
            requests: replaceByTargetFromArray(requests, data),
            requestsNext: requestsNext,
            requestsUnreadCount: requestsUnreadCount - 1
          }
        })
    }).catch(error => {
      dispatch({
        type: GET_REQUESTS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function wsAppendRequest(requestData) {
  const { requests, requestsNext, requestsUnreadCount } = store.getState().notifications
  const requestParsed = JSON.parse(requestData)
  return function action(dispatch) {
    const index = findIndexById(requests, requestParsed.id)
    if (index === -1) {
      dispatch({
        type: SET_REQUESTS,
        payload: {
          requests: [...[requestParsed], ...requests],
          requestsNext: requestsNext,
          requestsUnreadCount: requestsUnreadCount + 1
        }
      })
    } else {
      const reordered = moveToFirstById(requests, requestParsed.id)
      dispatch({
        type: SET_REQUESTS,
        payload: {
          requests: replaceByTargetFromArray(reordered, requestParsed),
          requestsNext: requestsNext,
          requestsUnreadCount: requestsUnreadCount + 1
        }
      })
    }
  }
}

export function wsAppendNotification(notificationData) {
  const { notifications, notificationsNext, notificationsUnreadCount } = store.getState().notifications
  const notificationParsed = JSON.parse(notificationData)
  return function action(dispatch) {
    const index = findIndexById(notifications, notificationParsed.id)
    if (index === -1) {
      dispatch({
        type: SET_NOTIFICATIONS,
        payload: {
          notifications: [...[notificationParsed], ...notifications],
          notificationsNext: notificationsNext,
          notificationsUnreadCount: notificationsUnreadCount + 1
        }
      })
      dispatch(setNotificationsNumber(notificationsUnreadCount + 1))
    } else {
      const reordered = moveToFirstById(notifications, notificationParsed.id)
      dispatch({
        type: SET_NOTIFICATIONS,
        payload: {
          notifications: replaceByTargetFromArray(reordered, notificationParsed),
          notificationsNext: notificationsNext,
          notificationsUnreadCount: notificationsUnreadCount + 1
        }
      })
      dispatch(setNotificationsNumber(notificationsUnreadCount + 1))
    }
  }
}

export function getCommonNotifications(next, sorting, search) {
  return function action(dispatch) {
    dispatch({
      type: GET_COMMON_NOTIFICATIONS
    })
    const url = next || `${apiUrl}common-notifications/`
    const params = {}
    if (sorting) {
      params['sorting'] = sorting
    }
    if (search) {
      params['search'] = search
    }
    axios.get(url, { params }).then((body) => {
      const { data } = body
      if (next) {
        const { commonNotifications } = store.getState().notifications
        dispatch({
          type: SET_COMMON_NOTIFICATIONS,
          payload: {
            commonNotifications: [...commonNotifications, ...data.results],
            commonNotificationsNext: data.next,
            commonNotificationsUnreadCount: data.unread_count
          }
        })
      } else {
        dispatch({
          type: SET_COMMON_NOTIFICATIONS,
          payload: {
            commonNotifications: data.results,
            commonNotificationsNext: data.next,
            commonNotificationsUnreadCount: data.unread_count
          }
        })
      }
    }).catch(error => {
      dispatch({
        type: GET_COMMON_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function getUnreadCommonNotifications() {
  return function action(dispatch) {
    const url = `${apiUrl}common-notifications/get_unread/`
    axios.get(url).then((body) => {
      const { data } = body
        dispatch({
          type: SET_UNREAD_COMMON_NOTIFICATIONS,
          payload: {
            commonNotificationsUnreadCount: data.unread_count
          }
        })
    }).catch(error => {
      dispatch({
        type: GET_COMMON_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function setAllReadCommonNotifications() {
  return function action(dispatch) {
    const url = `${apiUrl}common-notifications/read_all/`
    axios.put(url, {}).then((body) => {
        const { commonNotifications, commonNotificationsNext } = store.getState().notifications
        dispatch({
          type: SET_COMMON_NOTIFICATIONS,
          payload: {
            commonNotifications: updateAttrByIdArray(commonNotifications, getIdArray(commonNotifications), 'read', true),
            commonNotificationsNext,
            commonNotificationsUnreadCount: 0
          }
        })
    }).catch(error => {
      dispatch({
        type: GET_COMMON_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function setReadCommonNotification(id) {
  return function action(dispatch) {
    const url = `${apiUrl}common-notifications/${id}/set_read/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
        const { commonNotifications, commonNotificationsNext, commonNotificationsUnreadCount } = store.getState().notifications
        dispatch({
          type: SET_COMMON_NOTIFICATIONS,
          payload: {
            commonNotifications: replaceByTargetFromArray(commonNotifications, data),
            commonNotificationsNext: commonNotificationsNext,
            commonNotificationsUnreadCount: commonNotificationsUnreadCount - 1
          }
        })
    }).catch(error => {
      dispatch({
        type: GET_COMMON_NOTIFICATIONS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function setReadCommonNotifications(ids) {
  return function action(dispatch) {
    const { commonNotifications, commonNotificationsNext, commonNotificationsUnreadCount } = store.getState().notifications
    dispatch({
      type: SET_COMMON_NOTIFICATIONS,
      payload: {
        commonNotifications: updateAttrByIdArray(commonNotifications, ids, 'read', true),
        commonNotificationsNext: commonNotificationsNext,
        commonNotificationsUnreadCount: commonNotificationsUnreadCount - ids.length()
      }
    })
  }
}

export function wsAppendCommonNotification(notificationData) {
  const { commonNotifications, commonNotificationsNext, commonNotificationsUnreadCount } = store.getState().notifications
  const { activeWorkspacePk } = store.getState().auth
  const notificationParsed = JSON.parse(notificationData)
  const { workspaces } = notificationParsed
  return function action(dispatch) {
    if (workspaces.includes(activeWorkspacePk)) {
      const index = findIndexById(commonNotifications, notificationParsed.id)
      if (index === -1) {
        dispatch({
          type: SET_COMMON_NOTIFICATIONS,
          payload: {
            commonNotifications: [...[notificationParsed], ...commonNotifications],
            commonNotificationsNext: commonNotificationsNext,
            commonNotificationsUnreadCount: commonNotificationsUnreadCount + 1
          }
        })
      } else {
        const reordered = moveToFirstById(commonNotifications, notificationParsed.id)
        dispatch({
          type: SET_COMMON_NOTIFICATIONS,
          payload: {
            commonNotifications: replaceByTargetFromArray(reordered, notificationParsed),
            commonNotificationsNext: commonNotificationsNext,
            commonNotificationsUnreadCount: commonNotificationsUnreadCount + 1
          }
        })
      }
    }
  }
}

export function setReadCommonNotificationClick() {
  const { commonNotificationsUnreadCount } = store.getState().notifications
  return function action(dispatch) {
    dispatch({
      type: SET_UNREAD_COMMON_NOTIFICATIONS,
      payload: {
        commonNotificationsUnreadCount: commonNotificationsUnreadCount - 1
      }
    })
  }
}

export function setRequestFilters(filters) {
  return {
    type: SET_REQUEST_FILTERS,
    payload: {
      filters
    }
  }
}

export function resetRequestFilters() {
  return {
    type: RESET_REQUEST_FILTERS
  }
}
